<div class="container-fluid bg-primary color-primary">
  <h1 class="color-primary app-name" > UPservice </h1>
  <img class="logo-splash" src="assets/logo/logo_brand_white.svg" alt="Legrand Logo">
  <div class="policy-container bg-secondary text-right">
    <div style="height:50px;" class="row m-0"></div>
    <div class="row m-0 p-4">
      <div class="ups-spacer"></div>
      <h2>{{translate.getTranslation('terms_condition_title') | uppercase}}</h2>
      <div class="ups-spacer"></div>
    </div>
    <div class="row mx-4 p-2">
      <span>
        {{translate.getTranslation('terms_condition_subtitle')}}
      </span>
    </div>
    <div class="row mx-4 px-3 py-1">
        <strong class="color-accent" (click)="goToLink(touLink)"> Terms and Conditions </strong>
        <mat-icon class="mx-3 color-accent" svgIcon="external-accent"></mat-icon>
    </div>
    <div class="row mx-4 px-3 py-1">
        <strong class="color-accent" (click)="goToLink(privacyLink)"> Privacy Policy </strong>
        <mat-icon class="mx-3" svgIcon="external-accent"></mat-icon>
    </div>
    <div class="row m-0 h-25"> </div>
    <button class="btn btn-default bg-accent color-primary m-5 my-3" (click)="accept()"> {{translate.getTranslation('action_accept') | uppercase}} </button>
  </div>
</div>
